import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemUpgradeListingModel extends IModel {
  salesItemId: number;
  salesItemTypeId: number;
  speciesId: number | undefined;
  name: string;
  fullName: string;
}

export class SalesItemUpgradeListingModel
  extends Model
  implements ModelRecord<ISalesItemUpgradeListingModel>
{
  salesItemId: number;
  salesItemTypeId: number;
  speciesId: number | undefined;
  name: string;
  fullName: string;

  constructor(params?: Partial<ISalesItemUpgradeListingModel>) {
    super(params);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesItemTypeId = defaultTo(params?.salesItemTypeId, 0);
    this.speciesId = defaultTo(params?.speciesId, undefined);
    this.name = defaultTo(params?.name, '');
    this.fullName = defaultTo(params?.fullName, '');
  }
}
